import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'
import './Projects.css'
import projectData from './projectData.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class Projects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: projectData.data,
      title: projectData.data[0].title,
      description: projectData.data[0].description,
      image: projectData.data[0].image,
      image0: projectData.data[0].image,
      image1: projectData.data[1].image,
      image2: projectData.data[2].image,
      image3: projectData.data[3].image,
      deployLink: projectData.data[0].deployLink,
      githubLink: projectData.data[0].githubLink,
      techs: projectData.data[0].techs,
      image0anim: 'imageAnim',
      image1anim: null,
      image2anim: null,
      image3anim: null
    }
  }

  handleClick(e, i) {
    this.setState({
      title: projectData.data[i].title,
      description: projectData.data[i].description,
      image: projectData.data[i].image,
      deployLink: projectData.data[i].deployLink,
      githubLink: projectData.data[i].githubLink,
      techs: projectData.data[i].techs
    })

    for (var j = 0; j < 4; j++) {
      var imageNumb = `image${j}anim`
      this.setState({ [imageNumb]: null })
    }

    var imageNum = `image${i}anim`
    this.setState({ [imageNum]: 'imageAnim' })
  }

  render() {
    let projs = this.state.data.map((proj, index) => {
      return (
        <div
          onClick={e => this.handleClick(e, index)}
          className="proj"
          key={index}
        >
          {proj.title}
        </div>
      )
    })

    let listTechs = this.state.techs.map((tech, index) => {
      return (
        <div className="projTech" key={index}>
          {tech}
        </div>
      )
    })

    return (
      <div className="projectsContainer">
        <div className="projectList">{projs}</div>

        <div className="projectContainer">
          <div className="imageContainer">
            {/* <img className="project-image" src={this.state.image} alt="" /> */}

            <img
              className={`project-image image0 ${this.state.image0anim}`}
              src={this.state.image0}
              alt=""
            />
            <img
              className={`project-image image0 ${this.state.image1anim}`}
              src={this.state.image1}
              alt=""
            />
            <img
              className={`project-image image0 ${this.state.image2anim}`}
              src={this.state.image2}
              alt=""
            />
            <img
              className={`project-image image0 ${this.state.image3anim}`}
              src={this.state.image3}
              alt=""
            />
          </div>

          <div className="projectDescriptionContainer">
            <p className="projectTitle">{this.state.title}</p>
            <div className="listTechs">{listTechs}</div>
            <br />
            <p className="projectDescriptionText">{this.state.description}</p>
            <div className="view-links">
              <a
                className="view-link"
                href={this.state.deployLink}
                target="_blank"
              >
                <FontAwesomeIcon
                  className="fas fa-window-restore"
                  icon="window-restore"
                />
                View Site
              </a>

              <a
                className="view-link"
                href={this.state.githubLink}
                target="_blank"
              >
                <FontAwesomeIcon className="fas fa-code" icon="code" />
                View Code
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/Projects.js